import { Checkbox, FormControlLabel, Grid, TextField } from "@material-ui/core";
import CustomInput from "components/CustomInput";
import { orderBy } from "lodash";
import { arrayToObject } from "utils/object-util";
import { excludedTypes, vdFieldGroup, vehicle_detail_extended_type, vehicleDetailExtendedGroups, vehicleDetailExtendedMulti, vehicleDetailExtendedTypeLabels, vehicleDetailExtendedValues } from "../VehicleDetailExtended/VehicleDetailExtendedTypes";
import { useGetExtendedFieldTypesQuery } from "../vehicleSlice";
import MonthYearPicker from "components/MonthYearPicker/MonthYearPicker";
import moment from "moment";
import DropdownFilter from "components/DropdownFilter";
import { editAssetStyle } from "./style";
import VinMatching from "../components/VinMatching/VinMatching";
import { DateTimePicker } from "@mui/x-date-pickers";
import DateTimeField from "components/DateTimePicker/DateTimePicker";

export const EditExtendedInfo = ({ extendedInfo = [], onChangeField, decodedData, colorDecoded }) => {

    const classes = editAssetStyle();

    let { data: fieldConfig, error: fieldsError, isLoading: isLoadingFields } = useGetExtendedFieldTypesQuery();

    const data = arrayToObject(extendedInfo, 'vehicleDetailExtendedTypeId');

    const vehicleExtendedComponent = (field) => {
        if (vehicleDetailExtendedMulti?.[field?.id]) {
            let val = [];
            try {
                val = JSON.parse(data[field.id]?.value ?? "[]")
            } catch (e) {
            }
            return <DropdownFilter
                multiple
                title={vehicleDetailExtendedTypeLabels?.[field.id]}
                showEmpty
                value={val}
                values={vehicleDetailExtendedValues?.[field.id]}
                onSelect={val => {
                    onChangeField(field.id, JSON.stringify(val))
                }}
            />
        }
        if (vehicleDetailExtendedValues?.[field?.id]) {
            if (!!(data[field.id]?.value) && !((vehicleDetailExtendedValues?.[field.id].map(v => v.id))?.includes(data[field.id]?.value))) {
                return <CustomInput
                    label={field.name}
                    value={data[field.id]?.value}
                    elementType="input"
                    onChange={val => onChangeField(field.id, val)}
                />;
            }

            return <DropdownFilter
                title={vehicleDetailExtendedTypeLabels?.[field.id]}
                showEmpty
                value={data[field.id]?.value}
                values={vehicleDetailExtendedValues?.[field.id]}
                onSelect={val => onChangeField(field.id, val)}
            />
        }
        switch (field?.id) {
            case vehicle_detail_extended_type.keys_handed_over:
            case vehicle_detail_extended_type.fobs_handed_over:
            case vehicle_detail_extended_type.check_under_hood:
            case vehicle_detail_extended_type.PassengerSideAttachments:
            case vehicle_detail_extended_type.InteriorAttachments:
            case vehicle_detail_extended_type.ItemsAttachedToBody:
            case vehicle_detail_extended_type.CustomField1:
            case vehicle_detail_extended_type.SpotReservationNumber:
                return <CustomInput
                    label={field.name}
                    value={data[field.id]?.value}
                    elementType="input"
                    onChange={val => onChangeField(field.id, val)}
                />;
            // case vehicle_detail_extended_type.storage_type:
            //     return <DropdownFilter
            //         title='Select storage type'
            //         showEmpty
            //         value={data[field.id]?.value}
            //         values={storageTypes}
            //         onSelect={val => onChangeField(field.id, val)}
            //     />
            case vehicle_detail_extended_type.DOT_last_inspection_date:
            case vehicle_detail_extended_type.last_state_inspection_date:
                return <MonthYearPicker
                    label={field.name}
                    onChange={(value) => {
                        const val = moment(value).format("YYYY-MM");
                        onChangeField(field.id, val);
                    }}
                    value={data[field.id]?.value ? moment(data[field.id]?.value + "-01").toDate() : null} />;
            case vehicle_detail_extended_type.ExpectedArrival:
            case vehicle_detail_extended_type.ExpectedDeparture:
                return <DateTimeField
                    label={field.name}
                    value={data[field.id]?.value ?? null}
                    onChange={((val) => {
                        onChangeField(field.id, val);
                    })}
                />;
            case vehicle_detail_extended_type.ChargeLevel:
                return <CustomInput
                    label={field.name}
                    value={data[field.id]?.value}
                    elementType="input"
                    onChange={val => onChangeField(field.id, val)}
                    numberOnly
                />;
            case vehicle_detail_extended_type.VehicleWeight:
                return <Grid xs={12} className={classes.input}>
                    <CustomInput
                        label={field.name}
                        value={data[field.id]?.value}
                        elementType="input"
                        onChange={val => onChangeField(field.id, val)}
                        numberOnly
                        colorInput={colorDecoded} />
                    {decodedData && <VinMatching decodedData={decodedData?.weight} editedData={extendedInfo?.find(x => x.vehicleDetailExtendedTypeId === vehicle_detail_extended_type.VehicleWeight)?.value} field='weight' />}
                </Grid>;
            case vehicle_detail_extended_type.VehicleWeightClass:
                return <Grid xs={12} className={classes.input}>
                    <CustomInput
                        label={field.name}
                        value={data[field.id]?.value}
                        elementType="input"
                        onChange={val => onChangeField(field.id, val)}
                    />;

                    {decodedData && (
                        <VinMatching
                            decodedData={decodedData?.weightClass}
                            editedData={
                                extendedInfo?.find(
                                    x => x.vehicleDetailExtendedTypeId === vehicle_detail_extended_type.VehicleWeightClass
                                )?.value
                            }
                            field="weight class"
                        />
                    )}
                </Grid>

            default:
                return undefined;
        }
    }


    const defaultComponent = (field) => {
        return <FormControlLabel
            label={field?.name}
            control={<Checkbox
                title={field?.name}
                checked={data[field?.id]?.value == "Yes" ? true : false}
                onChange={(e, value) => onChangeField(field?.id, value, true)}
            />}
        />
    }

    const getField = (f) => {
        const comp = vehicleExtendedComponent(f);
        return ({
            component: comp ?? defaultComponent(f),
            type: comp ? '1' : '2',
            field: f
        });

    }

    const filteredFields = fieldConfig?.filter(f => !excludedTypes.includes(f.id)) ?? [];

    const fieldWithComponent = orderBy(filteredFields?.map(f => {
        return getField(f);
    }), 'type');

    const fieldConfigLookup = arrayToObject(filteredFields);
    const vdExtendedDataGrouped = {};

    //const allFields = fieldWithComponent.filter(f => !inspectionsPresentAndDates.includes(f.field.id));
    //const inspections = inspectionsPresentAndDates.map(f => getField(fieldConfigLookup[f]));
    // fieldWithComponent.map(field => {
    //     vdExtendedDataGrouped[vdFieldGroup[field.field.id]?.group] = [
    //         ...(vdExtendedDataGrouped[vdFieldGroup[[field.field.id]]?.group] ?? []),
    //         field
    //     ]
    // })

    Object.values(vehicleDetailExtendedGroups).map(group => {
        group.fields?.map(field => {
            vdExtendedDataGrouped[vdFieldGroup[field]?.group] = [
                ...(vdExtendedDataGrouped[vdFieldGroup[[field]]?.group] ?? []),
                ...(fieldConfigLookup[field] ? [getField(fieldConfigLookup[field])] : [])
            ]
        })
    })


    return (
        <>
            {/* {inspections?.map(f => <Grid item xs={6} container>
                {f.component}
            </Grid>)} */}
            {/* {allFields?.map(f => <Grid item xs={6} container>
                {f.component}
            </Grid>)} */}
            {Object.keys(vdExtendedDataGrouped)?.map(groupKey => <>
                <Grid className={classes.extendedFieldGroup} item xs={12}>{vehicleDetailExtendedGroups[groupKey]?.label}</Grid>
                {vdExtendedDataGrouped[groupKey].map(field =>
                    <Grid item xs={6} container>
                        {field.component}
                    </Grid>)}
            </>)
            }
        </>
    );
}